import React from 'react'
import { Icon, Typography, Button, Row, Col } from 'antd';
import { withApollo } from 'react-apollo'
import news1 from '../../../assets/images/news/news1-n.jpg'
import Container from '../../../components/user/Container'
import moment from 'moment'
import { Queries, Mutations } from '../../../graphql'
import { changeFormatdate } from '../../../utils/formatdate'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import ModalImage from '../../../components/user/ModalImage'
import ImageFile from '../../../components/user/ImageFile'
import { convertToHTMl } from '../../../utils/markDown'
import {decodeBase64} from '../../../utils/base64File'
import { apiKeyNews } from '../../../utils/apiKey'

const { Text, Title } = Typography
const axios = require('axios');

class DetailNews extends React.Component {

    state = {
        detailnews: "",
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        showModalImage: false
    }

    fetchListPost = async () => {
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchListPost,
            variables: {
                postId: match.url.split('/')[3]
            }
        })
        // console.log(data.fetchListPost.data[0]);
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        // console.log()
        await this.setState({
            detailnews: data.fetchListPost.data[0],
        })
    }

    showModalImage = () =>{
        this.setState({
            showModalImage:true
        })
    }

    hideModalImage = () =>{
        this.setState({
            showModalImage:false
        })
    }

    createPostRead = async (postId) => {
		const { client } = this.props
		try {
			let checkStatus = false
            const { data, errors } = await client.mutate({
                mutation: Mutations.createPostRead,
                variables: {
                    postId
                }
            })
		} catch (error) {
			console.log(error)
		}
	}



    async componentDidMount() {
        const { match } = this.props
        await this.createPostRead(match.url.split('/')[3])
        await this.fetchListPost()
    }


    render() {
        const { match } = this.props
        const { detailnews, showModalErrors, showModalImage } = this.state
        return (
            <Container match={match}>
               <div className="breadcrumb-custom pb-3 mb-5">
               {/* <Breadcrumb.Item> */}
                     <span style={{ fontSize:"18px" }}>ข่าวสาร </span>
               {/* </Breadcrumb.Item> */}
               </div>

                {
                    showModalErrors &&
                    <ModalErrors />
                }
                {
                    detailnews &&
                    <>
                        {
                            showModalImage &&
                            <ModalImage typeFile={detailnews.fileData.fileMimeType}  file={detailnews.fileData.fileId} hideModalImage={ this.hideModalImage }/>
                        }
                        <Row >
                            <Col span={16} offset={4}>
                                <div onClick={()=>this.showModalImage()}>
                                    <ImageFile typeFile={detailnews.fileData.fileMimeType}  file={detailnews.fileData.fileId}/>
                                </div>
                                <div>
                                <a href={'data:'+detailnews.fileData.fileMimeType+';base64,'+detailnews.fileData.fileId} className="mt-3 btn-color-default btn-custom color-white px-4 py-2 " download>ดาวน์โหลดรูปภาพ</a>
                                </div>
                                <Title level={4} className="pt-5" style={{ color:"#6b3432" }} >{detailnews.postTitleTH}</Title>
                                <Text style={{ fontSize: 12, color:"#9c9c9c" }} >{changeFormatdate(detailnews.updatedAt)}{moment(detailnews.updatedAt).format(' | เวลา HH:mm น.')}</Text><br />
                                <Text style={{ fontSize: 12, color:"#9c9c9c" }} >จำนวนผู้อ่าน { detailnews.readPost } คน</Text><br></br>
                                <div className="pt-3 pb-5">
                                    {
                                        detailnews.descriptionTH && 
                                        <div style={{color:"#9c9c9c" }} dangerouslySetInnerHTML={{ __html: convertToHTMl(detailnews.descriptionTH) }} />
                                    }
                                </div>
                                {
                                    detailnews.division &&
                                    <div className="mb-3">
                                        <p style={{ fontSize:"10px", lineHeight:"1.3"}}>ประกาศโดย : { detailnews.division }</p>
                                    </div>
                                }
                                {
                                    detailnews.linkOriginal&&
                                    <div style={{ textAlign: 'right' }}>
                                        <Button type="danger" href={detailnews.linkOriginal} target="_blank">
                                            ดูข่าวต้นฉบับ <Icon type="arrow-right" />
                                        </Button>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </>
                }

            </Container>
        )
    }
}

DetailNews.propTypes = {
    //
}

export default withApollo(DetailNews)